import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Artist } from './artists.service';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';

@Injectable({
  providedIn: 'root'
})
export class ConnectedNotesService extends ServiceBase {
  private _api = '/ConnectedNotes';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  public getConnectedNotes(artistId: string | null, galleryId: string | null): Observable<ConnectedNote[]> {
    const method: string = '/artists/' + artistId + '/galleries/' + galleryId + '/fetch';
    const url: string = environment.BASE_API_PATH + this._api + method;
    return this.http.get<ConnectedNote[]>(url, this.RequestHeaders());
  }

  public saveConnectedNotes(artistId: string | null, galleryId: string | null, note: string): Observable<ResponseObject> {
    const method: string = '/artists/' + artistId + '/galleries/' + galleryId + '/add-notes';
    const url: string = environment.BASE_API_PATH + this._api + method;
    return this.http.post<ResponseObject>(url, { Note: note }, this.RequestHeaders());
  }
}
export class ConnectedNote {
  Id!: string;
  ArtistId!: string;
  GalleryId!: string;
  Comments!: string;
  CommentsBy!: string;
  CreatedDate?: Date;
}